<template>
  <transition name="fade">
    <v-col cols="12" class="pa-0">
      <live-player-options
        :handleSelectOption="handleSelectOption"
        v-if="currentDisplay === 'options'"
      />
      <video-live
        v-if="currentDisplay === 'live'"
        :handleBack="handleBackOptions"
        :scheduled="scheduled"
        :serverStatus="serverStatus"
        :showScheduled="showScheduled"
        :timeLeft="timeLeft"
        :scheduled_at="scheduled_at"
        :handleInitNow="handleInitNow"
        :loadings="loadings"
        :errors="errors"
        :defaultThumbnail="defaultThumbnail"
        :imageError="imageError"
        :newThumbnail="newThumbnail"
        :handleChangeThumbnail="handleChangeThumbnail"
        :successfulChangedThumb="successfulChangedThumb"
        :liveInfo="liveInfo"
        :viewers="viewers"
        :liveStatus="liveStatus"
      />
    </v-col>
  </transition>
</template>

<script>
import VideoLive from './VideoLive.vue'
import LivePlayerOptions from './LivePlayerOptions.vue'

export default {
  name: 'LivePlayer',
  props: [
    'liveStatus',
    'viewers',
    'scheduled',
    'liveInfo',
    'serverStatus',
    'showScheduled',
    'timeLeft',
    'scheduled_at',
    'handleInitNow',
    'loadings',
    'errors',
    'defaultThumbnail',
    'imageError',
    'newThumbnail',
    'handleChangeThumbnail',
    'successfulChangedThumb',
  ],
  components: {
    VideoLive,
    LivePlayerOptions,
  },
  data: () => ({
    currentDisplay: 'options',
  }),
  methods: {
    handleSelectOption(option) {
      this.currentDisplay = option
    },
    handleBackOptions() {
      this.handleSelectOption('options')
    },
  },
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
